module.exports = __webpack_public_path__ + "img/car.531598e5.png";